import * as React from 'react'

import DynamicIcon from '@/components/DynamicIcon'
import Link from '@/components/Link'

const sizes = {
  default: 'rounded-2xl bg-yellow-400 p-4 hover:bg-white',
  small: 'text-violet-600 hover:text-purple-900',
}

const Social = ({icon = '', link, size}) => {
  return (
    <li className={sizes[size || 'default']}>
      <Link link={link}>{icon !== '' ? <DynamicIcon aria-hidden icon={icon} /> : null}</Link>
    </li>
  )
}

export default Social
